$(function () {

    // swiper
    var idxBannerSwiper = new Swiper(".index_banner", {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        effect: "fade",
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        on: {
            init: function () {
                updateIdxBannerPagination(this);
            },
            slideChange: function () {
                updateIdxBannerPagination(this);
            }
        }
    });

    // 左右箭頭點擊
    $(".idx-banner-arrow-left").on("click", function(){
        idxBannerSwiper.slidePrev();
    });
    $(".idx-banner-arrow-right").on("click", function(){
        idxBannerSwiper.slideNext();
    });

    // 分頁數字同步
    function updateIdxBannerPagination(swiper) {
        var total = swiper.slides.length;
        var realIndex = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
        var current = realIndex + 1;
        var $pagination = $(".idx-banner-pagination");
        $pagination.find(".current").text(current.toString().padStart(2, '0'));
        $pagination.find(".total").text(total.toString().padStart(2, '0'));
    }

    new Swiper(".idx_product", {
        autoHeight: true,
        navigation: {
            nextEl: ".idx_probtn_right",
            prevEl: ".idx_probtn_left",
        },
        loop: true,
    });

    // PAD_news_swiper

    new Swiper(".nsl_swiper_pad", {
        grabCursor: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        direction: 'horizontal',

        navigation: {
            nextEl: ".news-banner-pad-arrow-right",
            prevEl: ".news-banner-pad-arrow-left",
        },
        on: {
            init: function () {
                updateNewsBannerPadPagination(this);
            },
            slideChange: function () {
                updateNewsBannerPadPagination(this);
            },
            resize: function () {
                updateNewsBannerPadPagination(this);
            }
        }
    });






    // PC&MB_news_swiper

    var newsSwiper = new Swiper(".nsl_swiper", {
        grabCursor: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
            nextEl: ".news-banner-pc-arrow-right",
            prevEl: ".news-banner-pc-arrow-left",
        },
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            769: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
        on: {
            init: function () {
                updateNewsBannerPagination(this);
            },
            slideChange: function () {
                updateNewsBannerPagination(this);
            },
            resize: function () {
                updateNewsBannerPagination(this);
            }
        }
    });

    // 最新消息分頁數字同步
    function updateNewsBannerPagination(swiper) {

        const totalItems = swiper.slides.length;        // 資料筆數
        const itemsPerPage = swiper.params.slidesPerView;     // 每次移動幾筆，也視為每「一頁」幾筆
        const firstIndex = swiper.activeIndex;
        const lastVisibleIndex = Math.min(firstIndex + itemsPerPage - 1, totalItems - 1);

        // 頁碼應該根據「最後一個顯示中的資料」去算落在哪一頁
        const currentPage = Math.floor(lastVisibleIndex / itemsPerPage) + 1;
        const totalPages = Math.ceil(totalItems / itemsPerPage);

        let $pagination = $(".news-banner-pagination");
        $pagination.find(".current").text(currentPage.toString().padStart(2, '0'));
        $pagination.find(".total").text(totalPages.toString().padStart(2, '0'));

        console.log(`目前頁碼：第 ${currentPage} / ${totalPages} 頁`);
    }
    function updateNewsBannerPadPagination(swiper) {

        const totalItems = swiper.slides.length;        // 資料筆數
        const itemsPerPage = swiper.params.slidesPerView;     // 每次移動幾筆，也視為每「一頁」幾筆
        const firstIndex = swiper.activeIndex;
        const lastVisibleIndex = Math.min(firstIndex + itemsPerPage - 1, totalItems - 1);

        // 頁碼應該根據「最後一個顯示中的資料」去算落在哪一頁
        const currentPage = Math.floor(lastVisibleIndex / itemsPerPage) + 1;
        const totalPages = Math.ceil(totalItems / itemsPerPage);

        let $pagination = $(".news-banner-pad-pagination");
        $pagination.find(".current").text(currentPage.toString().padStart(2, '0'));
        $pagination.find(".total").text(totalPages.toString().padStart(2, '0'));

        console.log(`目前頁碼：第 ${currentPage} / ${totalPages} 頁`);
    }

    // if ($(window).width() <= 769) {
    //     $(".nsl_swiper")
    //         .find(".swiper-slide")
    //         .each(function (index) {
    //             if (index > 2) {
    //                 $(this).hide();
    //             }
    //         });
    // }

    // $(window).on("resize", function () {
    //     if ($(window).width() <= 769) {
    //         $(".nsl_swiper")
    //             .find(".swiper-slide")
    //             .each(function (index) {
    //                 if (index > 2) {
    //                     $(this).hide();
    //                 }
    //             });
    //     } else {
    //         $(".nsl_swiper")
    //             .find(".swiper-slide")
    //             .each(function () {
    //                 $(this).show();
    //             });
    //     }
    // });

    // witness swiper 3D 效果
    function updateWitnessPagination(swiper) {
        var total = swiper.slides.length;
        var realIndex = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
        var current = realIndex + 1;
        var $pagination = $(".witness-pagination");
        $pagination.find(".current").text(current.toString().padStart(2, '0'));
        $pagination.find(".total").text(total.toString().padStart(2, '0'));

    }

    var witnessSwiper = new Swiper('.witness-swiper', {
        slidesPerView: 1,
        centeredSlides: true,
        // loop: true,
        initialSlide: 0,
        spaceBetween: 0,
        effect: 'coverflow',
        coverflowEffect: {
            rotate: 0, // 不傾斜
            stretch: 0,
            depth: 280,
            modifier: 2,
            slideShadows: false,
        },
        navigation: {
            nextEl: '.witness-arrow-right',
            prevEl: '.witness-arrow-left',
        },
        // pagination: {
        //     el: '.witness-pagination',
        //     clickable: true,
        //     bulletClass: 'swiper-pagination-bullet',
        //     bulletActiveClass: 'swiper-pagination-bullet-active',
        // },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        breakpoints: {
            769: {
                slidesPerView: 1.2,
            },
            1200: {
                slidesPerView: 1.6,
            }
        },
        on: {
            init: function () {
                updateWitnessPagination(this);
            },
            slideChange: function () {
                updateWitnessPagination(this);
            }
        }
    });
    // // 只在初始化時補一次
    // setTimeout(function() {
    //     witnessSwiper.update();
    //     witnessSwiper.slideToLoop(0, 0, false);
    // }, 100);
    // // 等所有 witness_img 載入完畢後再 update
    // var $imgs = $('.witness_img');
    // var loadedCount = 0;
    // $imgs.each(function() {
    //     if (this.complete) {
    //         loadedCount++;
    //     } else {
    //         $(this).on('load error', function() {
    //             loadedCount++;
    //             if (loadedCount === $imgs.length) {
    //                 witnessSwiper.update();
    //             }
    //         });
    //     }
    // });
    // // 如果一開始就全部載入完畢
    // if (loadedCount === $imgs.length) {
    //     witnessSwiper.update();
    // }


    //Animation
    if ($("#rd-section-idx1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-idx2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-idx3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-idx4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx4").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-idx5").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx5",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx5").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-idx6").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx6",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx6").addClass("ani_do").removeClass("op0");
            },
        });
    }

    if ($("#rd-section-idx7").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-idx7",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-idx7").addClass("ani_do").removeClass("op0");
            },
        });
    }
});
